import { providers } from '../../providers';
import { wavespeed } from '../wavespeed';
import { atlascloud } from '../atlascloud';
import { getUiOptionsForModel } from '../ui-options';
import type { VideoModelEntry } from '../types';

// 价格表: 美元/秒
const FLUX3 = { '720p': 0.17, '1080p': 0.29 };
// 查找价格函数
const lookup = (table: Record<string, number>, quality?: string) =>
    table[quality?.toLowerCase() ?? ''] ?? Math.max(...Object.values(table));
// 系数
const COST_FACTOR = 1.5;

const flux3Cost = {
    getCost: ({ duration, quality }: { duration?: number; quality?: string }) => {
        const billed = Math.min(20, Math.max(5, duration || 5));
        return billed * lookup(FLUX3, quality) * COST_FACTOR;
    },
    getPassCount: ({ duration, quality }: { duration?: number; quality?: string }) => {
        const billed = Math.min(20, Math.max(5, duration || 5));
        return billed * lookup(FLUX3, quality) * COST_FACTOR * 100;
    },
};

export const fluxModels: VideoModelEntry[] = [
    {
        id: 'flux-3',
        chef: providers['black-forest-labs'],
        providers: [
            {
                ...providers['black-forest-labs'],
                model: wavespeed('flux-3'),
                modelBackup: [atlascloud('flux-3')],
                getCost: flux3Cost.getCost,
                getPassCount: flux3Cost.getPassCount,
            },
        ],
        configByMode: {
            none: {
                aspectRatios: ['16:9', '9:16', '1:1', '4:3', '3:4', '2:1', '21:9'],
                durations: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                qualities: ['720p', '1080p'],
                inlineMedia: {
                    image: { allow: false },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first: {
                aspectRatios: ['match', '16:9', '9:16', '1:1', '4:3', '3:4', '2:1', '21:9'],
                durations: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                qualities: ['720p', '1080p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 1, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
            first_last: {
                aspectRatios: ['16:9', '9:16', '1:1', '4:3', '3:4', '2:1', '21:9'],
                durations: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                qualities: ['720p', '1080p'],
                inlineMedia: {
                    image: { allow: true, maxCount: 2, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            none: ['prompt'],
            first: ['prompt', 'image'],
            first_last: ['prompt', 'image2'],
        },
        supportsEdit: false,
        supportsInput: ['t2v', 'first', 'first_last'],
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('flux-3'),
    },
    {
        id: 'flux-3-keyframes',
        chef: providers['black-forest-labs'],
        frameModeLabels: { ref: 'Keyframes' },
        providers: [
            {
                ...providers['black-forest-labs'],
                model: atlascloud('flux-3-keyframes'),
                getCost: flux3Cost.getCost,
                getPassCount: flux3Cost.getPassCount,
            },
        ],
        configByMode: {
            ref: {
                aspectRatios: ['16:9', '9:16', '1:1', '4:3', '3:4', '2:1', '21:9'],
                durations: [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20],
                qualities: ['720p', '1080p'],
                inlineMedia: {
                    allowInline: true,
                    image: { allow: true, maxCount: 10, maxSize: '10MB', formats: ['image/png', 'image/jpeg', 'image/webp'] },
                    video: { allow: false },
                    audio: { allow: false },
                },
            },
        },
        precheckByMode: {
            ref: ['prompt', 'image'],
        },
        supportsEdit: true,
        supportsInput: ['reference'],
        priceIndicator: 'high',
        price: 'Dynamic',
        uiOptions: getUiOptionsForModel('flux-3-keyframes'),
    },
];